import { render, staticRenderFns } from "./reviewOld.vue?vue&type=template&id=63f14a76&scoped=true"
import script from "./reviewOld.vue?vue&type=script&lang=js"
export * from "./reviewOld.vue?vue&type=script&lang=js"
import style0 from "./reviewOld.vue?vue&type=style&index=0&id=63f14a76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f14a76",
  null
  
)

export default component.exports